import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { forwardRef as T } from "react";
import { BaseIcon as d } from "../BaseIcon/index.js";
import { TooltipTrigger as x, Tooltip as _ } from "../Tooltip/index.js";
import '../../assets/index7.css';const b = "_infoTooltip_bmv8h_1", g = {
  infoTooltip: b
}, v = T(
  ({ children: i, placement: r, size: t = "md", id: n, m, mt: p, mr: e, mb: f, ml: l, ...s }, a) => /* @__PURE__ */ c(x, { delay: "immediate", children: [
    /* @__PURE__ */ o(
      d,
      {
        size: t,
        id: n,
        m,
        mt: p,
        mr: e,
        mb: f,
        ml: l,
        ref: a,
        className: g.infoTooltip,
        icon: "info",
        description: s["aria-label"]
      }
    ),
    /* @__PURE__ */ o(_, { placement: r, children: i })
  ] })
);
export {
  v as InfoTooltip
};
//# sourceMappingURL=index.js.map
